import React from 'react'
import WorkforceManagementsec1 from './WorkforceManagementsec1/WorkforceManagementsec1'
import WorkforceManagementsec2 from './WorkforceManagementsec2/WorkforceManagementsec2'
import WorkforceManagementsec3 from './WorkforceManagementsec3/WorkforceManagementsec3'
import WorkforceManagementsec4 from './WorkforceManagementsec4/WorkforceManagementsec4'

function WorkforceManagement() {
  return (
    <>
      <WorkforceManagementsec1 />
      <WorkforceManagementsec2 />
      <WorkforceManagementsec3 />
      <WorkforceManagementsec4 />
    </>
  )
}

export default WorkforceManagement
